import config from 'config'
import {
  ActivityOverviewAssessor,
  RPDetailAssessor,
  RPReportAssessor
} from 'containers/pages'
import React from 'react'
import { get } from 'lodash'

const urlPrefix = `${config.publicPath}/assessor/residential-project/:rpId`


export default [

  {
    path: `${urlPrefix}`,
    component: props => (
      <RPDetailAssessor
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: [
      {
        path: `${urlPrefix}/report`,
        component: props => (
          <RPReportAssessor
            params={get(props, 'match.params', {})}
            {...props}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/overview`,
        component: props => (
          <ActivityOverviewAssessor
            params={get(props, 'match.params', {})}
            {...props}
          />
        ),
        routes: []
      }
    ]
  }
]
